<!-- 选购 -->
<template>
<div class="m-choose">
    <img class="banner" :src="require('@/common/images/mSpecialTopic/choose/banner.jpg')" />
    <div class="choose-content">
        <div class="topic-item" v-for="(item) in list" :key="item.examcode">
            <div class="topic-name">{{item.topicname}}</div>
            <div class="subject-list">
                <div class="subject-item" @click="handleOpenSubjectDetails(item, option)" v-for="(option) in item.subject" :key="option.subjectcode">
                    <img :src="option.banner" class="banner" />
                    <div class="text-info">
                        <div class="label text-ellipses">{{option.showLabel}}</div>
                        <div class="uprice">￥{{option.uprice}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import specialTopic from '@/common/js/specialTopic.json'
import {getTopicQBBaseInfoAll} from '@/api/specialTopic.js'
import subjectBanner1 from '@/common/images/mSpecialTopic/choose/subject_banner1.png'
import subjectBanner2 from '@/common/images/mSpecialTopic/choose/subject_banner2.png'
import subjectBanner3 from '@/common/images/mSpecialTopic/choose/subject_banner3.png'
import subjectBanner4 from '@/common/images/mSpecialTopic/choose/subject_banner4.png'
import subjectBanner5 from '@/common/images/mSpecialTopic/choose/subject_banner5.png'
import subjectBanner6 from '@/common/images/mSpecialTopic/choose/subject_banner6.png'
import subjectBanner7 from '@/common/images/mSpecialTopic/choose/subject_banner7.png'
import subjectBanner8 from '@/common/images/mSpecialTopic/choose/subject_banner8.png'
import subjectBanner9 from '@/common/images/mSpecialTopic/choose/subject_banner9.png'
import subjectBanner10 from '@/common/images/mSpecialTopic/choose/subject_banner10.png'
import subjectBanner11 from '@/common/images/mSpecialTopic/choose/subject_banner11.png'
import subjectBanner12 from '@/common/images/mSpecialTopic/choose/subject_banner12.png'
import subjectBanner13 from '@/common/images/mSpecialTopic/choose/subject_banner13.png'
import subjectBanner14 from '@/common/images/mSpecialTopic/choose/subject_banner14.png'
import subjectBanner15 from '@/common/images/mSpecialTopic/choose/subject_banner15.png'
import subjectBanner16 from '@/common/images/mSpecialTopic/choose/subject_banner16.png'
export default {
    data() {
        return {
            subjectlist: [],
            list: [],
            subjectBanner1,
            subjectBanner2,
            subjectBanner3,
            subjectBanner4,
            subjectBanner5,
            subjectBanner6,
            subjectBanner7,
            subjectBanner8,
            subjectBanner9,
            subjectBanner10,
            subjectBanner11,
            subjectBanner12,
            subjectBanner13,
            subjectBanner14,
            subjectBanner15,
            subjectBanner16,
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {
        if(!this.domainInfo.isMobile){
            this.$router.push({
                name: 'SpecialChoose'
            })
        }
        this.subjectlist = JSON.parse(JSON.stringify(specialTopic.buySubjectList))
        this.handleGetTopicQBBaseInfoAll()
    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleGetTopicQBBaseInfoAll() {
            this.setLoading(true)
            getTopicQBBaseInfoAll({
                data: {},
                success: data => {
                    data.data.forEach(item => {
                        if (item.examcode === 'jjcy') {
                            item.topicname = '基金题库'
                        } else if (item.examcode === 'zqcy') {
                            item.topicname = '证券题库'
                        } else if (item.examcode === 'qhcy') {
                            item.topicname = '期货题库'
                        }
                        let subject = []
                        this.subjectlist.some(option => {
                            if (option.examcode === item.examcode) {
                                subject = JSON.parse(JSON.stringify(option.subjectList))
					            return true
                            }
                        })
                        subject.forEach(option => {
                            option.uprice = item[option.upricename]
                            option.banner = this[option.bannername]
                        })
                        item.subject = subject
                    })
                    this.list = data.data
                    this.setLoading(false)
                },
                error: error => {
                    this.setLoading(false)
                    this.$toast.fail(error.msg)
                }
            })
        },
        handleOpenSubjectDetails(item, option) {
            localStorage.setItem('topicItem', JSON.stringify(Object.assign({}, option, {examcode: item.examcode})))
            this.$router.push({
                name: 'MSpecialTopicDetails'
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters(['domainInfo'])
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.m-choose {
    .banner {
        width: 100%;
        height: 2.35rem;
    }
    .choose-content {
        padding: 0.32rem 0.28rem 0;
        box-sizing: border-box;
        .topic-item {
            margin-bottom: 0.32rem;
            .topic-name {
                font-size: 0.32rem;
                color: #333333;
                line-height: 0.45rem;
                margin-bottom: 0.32rem;
                font-weight: bold;
            }
            .subject-list {
                display: flex;
                align-items: stretch;
                flex-wrap: wrap;
                .subject-item {
                    width: 3.33rem;
                    height: 3.63rem;
                    border-radius: 0.1rem;
                    box-shadow: 0rem 0rem 0.1rem 0rem rgba(0,0,0,0.2);
                    margin-bottom: 0.28rem;
                    background: #fff;
                    &:not(:nth-of-type(2n)) {
                        margin-right: 0.2rem;
                    }
                    .banner {
                        width: 100%;
                        height: 1.86rem;
                        border-radius: 0.1rem 0.1rem 0 0;
                    }
                    .text-info {
                        padding: 0.2rem;
                        box-sizing: border-box;
                        .label {
                            font-size: 0.3rem;
                            color: #333333;
                            line-height: 0.42rem;
                            margin-bottom: 0.1rem;
                        }
                        .uprice {
                            font-size: 0.3rem;
                            color: #FA2B19;
                            line-height: 0.42rem;
                            font-weight: bold;
                        }
                    }
                }
            }
        }
    }
}
</style>